import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'

import NotFound from '../Pages/NotFound'

import List from './Order/List'
import ChatbotList from './Order/ChatbotList'
import DetailList from './Order/DetailList'
import AutoTransferList from './Order/AutoTransferList'
import ChangeStatus from './Order/ChangeStatus'

const subList = {
  List: <List />,
  ChatbotList: <ChatbotList />,
  DetailList: <DetailList />,
  AutoTransfer: <AutoTransferList />,
  ChangeStatus: <ChangeStatus />
}

const SubComponent = ({ subname = 'list' }) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound />
  }
}

const OrderPage = ({ location, match }) => <SubComponent subname={match.params.sub} location={location} />

export default OrderPage



// WEBPACK FOOTER //
// ./src/Pages/OrderPage.js